import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouteData, withSiteData } from 'react-static';
import { getUrlWithStickyParams } from '../../util';

class Hyperlink extends React.Component {
  state = {
    link: this.props.to,
  };

  componentDidMount() {
    const { to, basename } = this.props;
    // eslint-disable-next-line
    this.setState({ link: getUrlWithStickyParams(to, basename) });
  }

  render() {
    const { children, className, openInNewTab, onClick, 'aria-label': ariaLabel } = this.props;
    const linkAttributes = {
      className,
      onClick,
      ...(openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}),
      ...(onClick ? { href: this.state.link } : { to: this.state.link }),
      ...{ 'aria-label': ariaLabel || '' },
    };

    const LinkWrapper = onClick ? 'a' : Link;
    return <LinkWrapper {...linkAttributes}>{children}</LinkWrapper>;
  }
}

Hyperlink.propTypes = {
  'children': PropTypes.node,
  'to': PropTypes.string.isRequired,
  'basename': PropTypes.string,
  'openInNewTab': PropTypes.bool,
  'className': PropTypes.string,
  'onClick': PropTypes.func,
  'aria-label': PropTypes.string,
};

export default withSiteData(withRouteData(Hyperlink));



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/common/Hyperlink.js